/** Meta naslovi i opisi po stranicama (srpski). */
export const SEO = {
  home: {
    title: 'Početna',
    description:
      'THERMO COOL SYSTEM — klimatizacija, grejanje i ventilacija za dom i posao. Ugradnja, servis i konsultacije. Kovačevac, Prijepolje, šira Srbija.',
    path: '/',
  },
  usluge: {
    title: 'Usluge',
    description:
      'Klimatizacija, grejanje, ventilacija, servis i održavanje HVAC sistema. Split i multi-split, podno grejanje, rekuperacija — THERMO COOL SYSTEM.',
    path: '/usluge',
  },
  oNama: {
    title: 'O nama',
    description:
      'Ko smo mi, iskustvo i vrednosti THERMO COOL SYSTEM. Pouzdan partner za HVAC u Srbiji — stručnost, garancija i transparentnost.',
    path: '/o-nama',
  },
  projekti: {
    title: 'Projekti',
    description:
      'Projekti u toku i završeni radovi — klimatizacija, grejanje, ventilacija. THERMO COOL SYSTEM, Prijepolje i šira Srbija.',
    path: '/projekti',
  },
  projektiUToku: {
    title: 'Projekti u toku',
    description:
      'Aktivna gradilišta i radovi u realizaciji — THERMO COOL SYSTEM, HVAC instalacije.',
    path: '/projekti/u-toku',
  },
  projektiZavrseni: {
    title: 'Završeni projekti',
    description:
      'Realizovani projekti — klimatizacija, grejanje, ventilacija. Reference THERMO COOL SYSTEM.',
    path: '/projekti/zavrseni',
  },
  kontakt: {
    title: 'Kontakt',
    description:
      'Kontaktirajte THERMO COOL SYSTEM — upit, ponuda, hitna intervencija. Telefon, WhatsApp, Viber, forma. Adresa: Kovačevac, opština Prijepolje.',
    path: '/kontakt',
  },
};
